import ApexChartSeries from '@/ship/Models/ProjectManagement/Report/ApexChartSeries';
import { Buffer, ConstructionReport } from '@/ship/Models/ProjectManagement/Report/ContructionReport';
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import { createAnnualConstructionReport } from '@/utils/api/ProjectManagement/Reports';
import ErrorService from '@/utils/ErrorService';
import { fromISODateToLocal } from '@/utils/Helper';
import { ref } from 'vue';

export function useReportConstruction() {
    const report = ref<ConstructionReport | null>(null);
    const series = ref<ApexChartSeries[]>();
    const isLoading = ref<boolean>(false);
    const isRequestMade = ref(false);

    const createReport = async (id: number, data: any, params?: GetRequestParams) => {
        report.value = null;
        series.value = [];
        isRequestMade.value = true;
        isLoading.value = true;

        try {
            const result = await createAnnualConstructionReport(id, data, params);

            report.value = result.data;

            series.value = [
                {
                    name: 'Буфер',
                    data: result.data.buffersData.map((item: Buffer) => {
                        const localDate = fromISODateToLocal(item.startDate);
                        const [day, month] = localDate.split('.');

                        return {
                            x: `${day}.${month}`,
                            y: item.versionBuffer,
                            date: localDate,
                        };
                    }),
                },
            ];
        } catch (err) {
            ErrorService.handleApiError(err);
        } finally {
            isLoading.value = false;
        }
    };

    return {
        createReport,
        report,
        series,
        isLoading,
        isRequestMade,
    };
}
